function wishlist_general_add_and_update(variant_id, button) {
    //alert("wishlist_general_add_and_update(" + variant_id + ")");
    var params = {
        type: "POST",
        url: 'https://store.3dtotal.com/tools/downloadables/wishlist/add.php',
        data: {
            variant_id: variant_id
        },
        success: function(data) {
            //alert("got response " + data);
            button.innerHTML = 'Remove from wishlist'; 
            button.dataset['wishlistState'] = 'present';
            wishlist_general_update_buttons();
        }
    };
    $.ajax(params);
}

function wishlist_general_remove_and_update(variant_id, button) {
    //alert("wishlist_general_remove_and_update(" + variant_id + ")");
    var params = {
        type: "POST",
        url: 'https://store.3dtotal.com/tools/downloadables/wishlist/remove.php',
        data: {
            variant_id: variant_id
        },
        success: function(data) {
            //alert("got response " + data);
            button.innerHTML = 'Add to wishlist'; 
            button.dataset['wishlistState'] = 'absent';
            wishlist_general_update_buttons();
        }
    };
    $.ajax(params);
}

function wishlist_general_update_buttons() {
    // fetch the wishlist membership for the current user
    var params = {
        type: "GET",
        url: 'https://store.3dtotal.com/tools/downloadables/wishlist/get_variants_in_wishlist.php',
        data: {
            partial_mode: 'true'
        },
        success: function(stuff) {
            //console.log("wishlist_general_update_buttons() - got response: ");
            stuff = JSON.parse(stuff);
            //console.log(stuff);
            stuff.forEach(element => {
                //console.log(element);
                //console.log("wishlist_general_update_buttons() - got response: " + element['variant_id']);
                var button = document.querySelector("button[data-variant-id='" + element + "']");
                if (button) {
                    button.innerHTML = 'Remove from wishlist'; 
                    button.dataset['wishlistState'] = 'present';
                } /*else {
                    console.log("wishlist_general_update_buttons() - no button found for variant_id: " + element);
                }*/
            });
        }
    };
    $.ajax(params);
}

function wishlist_toggle_and_update(variant_id, button) {
    if (button.dataset['wishlistState'] == 'absent') {
        button.innerHTML = 'Adding to wishlist..'; 
        wishlist_general_add_and_update(variant_id, button);
    } else {    // already in wishlist
        button.innerHTML = 'Removing from wishlist..'; 
        wishlist_general_remove_and_update(variant_id, button);
    }  
}

(function($) {
    wishlist_general_update_buttons();
})(jQuery);